var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDurability = function SvgDurability(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m15.136 11.5 1.099 1.099.037.037a2.545 2.545 0 0 1-.036 3.598l-.037.037a2.545 2.545 0 0 1-3.6-.036l-1.792-1.793M8.63 6.721l-5.299-5.3-1.848 1.85 5.175 5.175"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m16.765 3.853-2.238 2.23-2.618-2.601 2.24-2.23a3.06 3.06 0 0 0-1.643-.223 4.083 4.083 0 0 0-3.732 4.162A3.1 3.1 0 0 0 9 6.382l-7.165 6.314a2.486 2.486 0 0 0-.201 3.51l.051.057a2.39 2.39 0 0 0 3.584-.146l6.345-7.133c.678.2 1.391.249 2.09.146A4.14 4.14 0 0 0 16.84 6.23a3.7 3.7 0 0 0-.074-2.378"
  })));
};
export default SvgDurability;